/**
 * directives.createPayment Module
 *
 * Description
 */
var app = angular.module('directives.common');

app.directive('cvvPopup', function($rootScope) {
    return {
        restrict: 'E',
        templateUrl: './app/directives/common/cvvPopup.html',
        scope: {
            cvvField: '='
        },
        controller: [
            '$scope',
            function ($scope) {
                var CvvForm = {
                    numbers:[1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
                    cvv: $scope.cvvField.value,
                    shuffle: function(array){
                        var counter = array.length, temp, index;

                        while (counter > 0) {
                            index = Math.floor(Math.random() * counter);
                            counter--;
                            temp = array[counter];
                            array[counter] = array[index];
                            array[index] = temp;
                        }

                        return array;
                    },
                    enterKey: function(value){
                        if(CvvForm.cvv.length < 3){
                            CvvForm.cvv += value;
                        }
                        if($scope.cvvField.error){
                            $scope.cvvField.error = false;
                        }
                    },
                    setCvv: function(){
                        $scope.cvvField.value = CvvForm.cvv;
                        $scope.cvvField.isShowPopupCvv = false;
                    },
                    close: function(){
                        CvvForm.cvv = '';
                        $scope.cvvField.isShowPopupCvv = false;
                    },
                    isShowCvv: false,
                    typeInput: 'password',
                    clickEye: function(){
                        CvvForm.isShowCvv = !CvvForm.isShowCvv;
                        if(CvvForm.isShowCvv){
                            CvvForm.typeInput = 'text';
                        } else {
                            CvvForm.typeInput = 'password';
                        }
                    },
                    clear: function(){
                        CvvForm.cvv = '';
                    }
                };
                CvvForm.numbers = CvvForm.shuffle(CvvForm.numbers);

                $scope.CvvForm = CvvForm;
            }
        ],
        link: function(scope, element, attrs, ngModelCtrl) {

        }
    };
});

app.directive('passwordRepeat', function () {
    var isValid = function (pass1, pass2) {
        return pass1 === pass2;
    };

    return {
        require: 'ngModel',
        scope: {
            passorigin: '='
        },
        link: function (scope, elm, attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.unshift(function (viewValue) {
                var validate = isValid(scope.passorigin, viewValue);
                ngModelCtrl.$setValidity('password-repeat', validate);
                return validate ? viewValue : null;
            });
        }
    };
});

app.directive('focusMe', ['$timeout', function ($timeout) {
    return {
        scope: {
            trigger: '=focusMe'
        },
        link: function (scope, element) {
            scope.$watch('trigger', function (value) {
                if (value === true) {
                    element[0].focus();
                    scope.trigger = false;
                }
            });
        }
    };
}]);

app.directive('month', function () {
    var isValid = function (str) {
        var newStr = str;
        if(newStr[0] == '0' || (newStr >=10 && newStr <=12))
            return true;
        else
            return false;
    };

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.unshift(function (viewValue) {
                var validate = isValid(viewValue);
                ngModelCtrl.$setValidity('month', validate);
                return validate ? viewValue : null;
            });
        }
    };
});

app.directive('year', function () {
    var isValid = function (str) {
        var newStr = str;
        if(newStr[0] == '0' || (newStr <= 99))
            return true;
        else
            return false;
    };

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ngModelCtrl) {
            ngModelCtrl.$parsers.unshift(function (viewValue) {
                var validate = isValid(viewValue);
                ngModelCtrl.$setValidity('year', validate);
                return validate ? viewValue : null;
            });
        }
    };
});

app.directive('validateCardNumber', ['$interval', function ($interval) {
    // Runs during compile
    return {
        // name: '',
        // priority: 1,
        // terminal: true,
        require: 'ngModel', // {} = isolate, true = child, false/undefined = no change
        // controller: function($scope, $element, $attrs, $transclude) {},
        // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
        restrict: 'AE', // E = Element, A = Attribute, C = Class, M = Comment
        // template: '',
        // templateUrl: '',
        // replace: true,
        // transclude: true,
        // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, el, attrs){}})),
        link: function ($scope, iElm, iAttrs, ngModel) {

            function cardFormat(value) {

                return value.replace(/[^\*\d]/g, '')
                    .replace(/([\*\d]{4})/g, '$1 ').trim().substring(0, 19);
            }

            ngModel.$parsers.unshift(function (value) {

                var valid = true;
                // var valid = isValid(value);

                ngModel.$setValidity('cardValidation', valid);

                return valid ? cardFormat(value) : null;
            })
        }
    };
}]);

   app.directive('float', function () {
        var isValid = function (str) {
            // return true;
            var regex = /^(?:[1-9]\d{1,3}|0)?(?:(\.|,)\d{2})?$/;
            return regex.test(str);
        };

        return {
            require: 'ngModel',
            link: function (scope, el, attrs, ngModelCtrl) {

                ngModelCtrl.$parsers.unshift(function (viewValue) {
                    var validate = isValid(viewValue);
                    ngModelCtrl.$setValidity('float', validate);
                    return validate ? parseFloat(viewValue.replace(',', '.')) : null;
                });

                el.bind('keyup change', function () {
                    if (angular.isFunction(ngModelCtrl.$viewValue.replace)) {
                        ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue.replace(/[^\d{0,16}(.|,)]/g, ""));
                        ngModelCtrl.$render();
                        scope.$apply();
                    }
                });
            }
        };
    });

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/common/directive.js
 ** module id = 148
 ** module chunks = 1
 **/